function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-298.000000, -377.000000)",
  fill: "#183E6B",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(214.000000, 362.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(68.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(16.000000, 15.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4,2 C4,3.1 3.3,4 2,4 C0.8,4 0,3.1 0,2.1 C0,1 0.8,0 2,0 C3.2,0 4,0.9 4,2 Z M0,18 L4,18 L4,5 L0,5 L0,18 Z M13.6,5.2 C11.5,5.2 10.3,6.4 9.8,7.2 L9.7,7.2 L9.5,5.5 L5.9,5.5 C5.9,6.6 6,7.9 6,9.4 L6,18 L10,18 L10,10.9 C10,10.5 10,10.2 10.1,9.9 C10.4,9.2 10.9,8.3 12,8.3 C13.4,8.3 14,9.5 14,11.1 L14,18 L18,18 L18,10.6 C18,6.9 16.1,5.2 13.6,5.2 Z"
})))))));
var SvgIconLinkedin = function SvgIconLinkedin(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLinkedin, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-linkedin.bae322ff.svg";
export { ForwardRef as ReactComponent };